import * as datetimes from '@/assets/mattick-shared/functions/datetimes'

export default () => ({
  ...datetimes,
})
